import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'recap-income-details',
    templateUrl: './recap-income-details.component.html',
    styleUrls: ['./recap-income-details.component.scss'],
    standalone: false
})
export class RecapIncomeDetailsComponent implements OnInit {
    /**
     * Event emitted to tell the parent to invoke the edit action
     * 
     * @type {EventEmitter<string>}
     * @memberof RecapIncomeDetailsComponent
     */
    @Output() stageChange: EventEmitter<string>;
    /**
     * Incoming income details data form the parent
     * 
     * @type {Array<Object>}
     * @memberof RecapIncomeDetailsComponent
     */
    @Input() incomeDetails: Array<Object>;
    /**
     * Flag to togle displaying the edit button
     * 
     * @type {boolean}
     * @memberof RecapIncomeDetailsComponent
     */
    @Input() showEditButton: boolean;
    constructor() {
        this.stageChange = new EventEmitter<string>();
    }

    ngOnInit() {
    }
    /**
     * emit stage change when edit button clicked
     * 
     * @memberof RecapLoanDetailsComponent
     */
    editButtonClicked(): void {
        this.stageChange.emit('tad_stage_income_details');
    }
}
